<div class="profile__wrapper">
  <div class="table-holiday" [class.table-nodata]="!tableData.length">
    <div class="table-desc">Holidays</div>
    <app-table
      [content]="tableData"
      [headers]="tableHeaders"
      [tableType]="'material-plus'"
      [editMenu]="'icon'"
      [showEditFields]="true"
      (rowAction)="showDialogWithData($event)"
      *ngIf="tableData.length"
      class="table-holiday"
    ></app-table>

    <button
      *ngIf="!tableData.length"
      type="button"
      class="button button__add--normal table-btn"
      (click)="addNewHoliday()"
    ></button>
  </div>
</div>
